// extracted by mini-css-extract-plugin
export var productImage = "_lw-1";
export var viewLink = "_lw-2";
export var wishlistItem = "_lw-0";